function initNewrumiShop(root){
  root.querySelectorAll('.shop').forEach(shop=>{
    if(shop.dataset.purchaseInitialized==='true')return;
    shop.dataset.purchaseInitialized='true';
    const labels=[...shop.querySelectorAll('.kit')];
    labels.forEach(label=>label.querySelector('input')?.addEventListener('change',()=>labels.forEach(l=>l.classList.toggle('selected',l.querySelector('input')?.checked))));
    const button=shop.querySelector('.buy-btn');if(!button)return;
    button.addEventListener('click',async()=>{
      if(button.disabled)return;
      const variantId=Number(button.dataset.variant);
      const quantity=Number(shop.querySelector('input[name="paw-kit"]:checked')?.value||1);
      const message=shop.querySelector('#cart-message');
      if(!variantId||![1,2,3].includes(quantity))return;
      const items=[{id:variantId,quantity}];
      const priority=shop.querySelector('#paw-priority');
      if(priority?.checked){const extra=Number(priority.dataset.variant);if(!extra){if(message)message.textContent='Priority processing is unavailable.';return;}items.push({id:extra,quantity:1});}
      button.disabled=true;
      if(message)message.textContent='Preparing secure checkout…';
      try{
        const base=window.Shopify?.routes?.root||'/';
        const response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        if(!response.ok){const error=await response.json().catch(()=>({}));throw new Error(error.description||error.message||'Unable to add items. Check inventory and product availability.');}
        window.location.assign(base+'checkout');
      }catch(error){if(message)message.textContent=error.message;button.disabled=false;}
    });
  });
}
document.addEventListener('DOMContentLoaded',()=>initNewrumiShop(document));
document.addEventListener('shopify:section:load',event=>initNewrumiShop(event.target));

// StoreForge V6 cart: native Shopify cart form for reliable quantity updates.
function initNewrumiCart(root){
  root.querySelectorAll('.sf-cart form').forEach(form=>{
    if(form.dataset.sfCartReady==='true')return;
    form.dataset.sfCartReady='true';
    let pending=false;
    const feedback=form.querySelector('.sf-cart-feedback');
    const update=()=>{
      if(pending)return;
      pending=true;
      if(feedback){feedback.hidden=false;feedback.textContent='Updating cart…';}
      const submit=document.createElement('button');
      submit.type='submit';submit.name='update';submit.value='Update cart';submit.hidden=true;
      form.appendChild(submit);submit.click();
    };
    form.querySelectorAll('[data-qty-step]').forEach(button=>button.addEventListener('click',()=>{
      const input=button.closest('.sf-cart-qty')?.querySelector('.sf-cart-qty-input');
      if(!input)return;
      const step=Number(button.dataset.qtyStep);
      input.value=String(Math.min(99,Math.max(0,(parseInt(input.value,10)||0)+step)));
      update();
    }));
    form.querySelectorAll('[data-cart-remove]').forEach(button=>button.addEventListener('click',()=>{
      const input=button.closest('.sf-cart-item')?.querySelector('.sf-cart-qty-input');
      if(!input)return;
      input.value='0';update();
    }));
    form.querySelectorAll('.sf-cart-qty-input').forEach(input=>input.addEventListener('change',()=>{
      input.value=String(Math.min(99,Math.max(0,parseInt(input.value,10)||0)));update();
    }));
  });
}
document.addEventListener('DOMContentLoaded',()=>initNewrumiCart(document));
document.addEventListener('shopify:section:load',event=>initNewrumiCart(event.target));
